<script setup>
import { ref, defineProps } from "vue";
const props = defineProps({
  doc: {
    type: Object,
    default: () => ({})
  },
  index: {
    type: Number,
    default: 0
  },
  link: {
    type: Boolean,
    default: false
  }

});

const labels = {
  houses: {
    "1": "1 Casa",
    "2-4": "2 a 4 Casas",
    "5-10": "5 a 10 Casas",
    ">10": "Más de 10 Casas",
  },
  markets: {
    "1": "1 Negocio",
    "2-4": "2 a 4 Negocios",
    "5-10": "5 a 10 Negocios",
    ">10": "Más de 10 Negocios",
  },
  vehicleType: {
    "car": "Cualquier Vehiculo",
    "truck": "Vehiculos Altos",
    "4x4": "Solo 4x4",
    "motorcycle": "Solo Motos",
    "bicycle": "Solo Bicicletas",
    "walking": "Solo Caminando",
  },
  security: {
    // tranquilo, normal, inseguro, peligroso, muy peligroso
    "low": "Zona Tranquila",
    "normal": "Precauciones normales",
    "unsafe": "Zona Insegura",
    "dangerous": "Zona Peligrosa",
    "very-dangerous": "Zona Muy Peligrosa",
  }
}

const getPointGpsUrl = (point) => {
  // `https://www.google.com/maps/search/?api=1&query=${puntoEncuentro.lat},${puntoEncuentro.lng}`
  if (!point) return '';
  if (!point.latlng) return '';
  console.log("point", point)
  return `https://www.google.com/maps/search/?api=1&query=${point.latlng.lat},${point.latlng.lng}`;
}

</script>

<template>
  <div class="mt-2 cursor-pointer point-detail flex gap-2">
    <div>

      <div class="black-point">
        {{ props.index + 1 }}
      </div>
    </div>
    <div v-if="[ 'home', 'market' ].includes(props.doc.type)">

      <div class="detail">
        
        <span v-if="props.doc.type === 'home'">
        {{ labels.houses[props.doc.houses] }}.
        </span>
        <span v-if="props.doc.type === 'market'">
        {{ labels.markets[props.doc.markets] }}.
        </span>
        {{ 
          labels.vehicleType[props.doc.vehicleType]
        }}. {{ 
          labels.security[props.doc.security]
        }}.
      </div>
      <div class="notes mt-1" v-if="props.doc.notes">
        {{ props.doc.notes }}
      </div>

      <div class="mt-0" v-if="props.link">
        <a :href="getPointGpsUrl(props.doc)" target="_blank" class="link mt-2">Abrir en Google Maps</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.point-detail {
  cursor: pointer;
  padding: 5px;
  margin: 5px 0;
  font-size: 1em;
  /* border-bottom: 1px solid #ddd; */
  /* border-radius: 5px; */
}
.point-detail h5 {
  margin: 0;
}
.detail, .notes {
  font-size: 0.8em;
}
.link {
  color: var(--accent);
  text-decoration: none;
  font-size: .7em;
}
.black-point {
  background-color: var(--success);
  color: #fff;
  padding: 5px;
  border-radius: var(--radius-sm);
  font-size: 0.8em;
}
</style>